import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentLanguage: 'en', // Default language
  supportedLanguages: [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'हिंदी' },
    // Add more languages as needed
  ],
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    },
    addSupportedLanguage: (state, action) => {
      state.supportedLanguages.push(action.payload);
    },
    removeSupportedLanguage: (state, action) => {
      state.supportedLanguages = state.supportedLanguages.filter(
        lang => lang.code !== action.payload
      );
    },
  },
});

export const { setLanguage, addSupportedLanguage, removeSupportedLanguage } = languageSlice.actions;

export default languageSlice.reducer; 